import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../store';
import { PathFinderControls } from './PathFinderControls';
import { PathTable } from './PathTable';

type Props = {
  showControls?: boolean;
  showTable?: boolean;
  scenario_id?: string;
  gas_date?: string;
};

export const PathFinder: React.FC<Props> = (props) => {
  const kPathsData = useSelector(
    (s: RootState) => (s as any).pathFinder?.results ?? [],
  );

  return (
    <>
      {!props.showControls && kPathsData.length === 0 && (
        <div className="alert alert-info m-2">
          Optionally select receipt and/or delivery asset points, then click
          "Find Paths".
        </div>
      )}
      {props.showControls && (
        <>
          <div className="mb-3 d-flex flex-column gap-3">
            <div className="d-flex flex-column">
              <h2>Path Finder</h2>
            </div>
          </div>
          <PathFinderControls
            scenario_id={props.scenario_id}
            gas_date={props.gas_date}
          />
        </>
      )}

      {props.showTable && (
        <PathTable
          pathData={kPathsData}
          sortable={true}
          initialSortKey={'profit'}
          initialSortDir={'desc'}
          showAvoidConstraints={true}
        />
      )}
    </>
  );
};
